import axios from 'axios'
import * as Util from '@/vuex/util'

const state = {
  ranks: []
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.ranks = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state, fullList = null) {
    state.ranks = []
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}, fullList) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.ranks
}

export const DistractedDrivingRank = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/barCharts/DistractedDrivingRank.js